import styled from '@emotion/styled'
import React, { forwardRef } from 'react'

export interface TextLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  tone?: 'light' | 'neutral' | 'action' | 'positive' | 'negative' | 'caution' | 'contrast'
  weight?: 'regular' | 'weak'
  children?: React.ReactNode
}

export const TextLink = forwardRef<HTMLAnchorElement, TextLinkProps>(
  ({ children, tone = 'action', weight = 'regular', ...props }, ref) => (
    <StyledAnchor ref={ref} tone={tone} weight={weight} {...props}>
      {children}
    </StyledAnchor>
  )
)

const StyledAnchor = styled.a<TextLinkProps>`
  color: ${(p) => `var(--colors-${p.tone});`}
  cursor: pointer;
  font-weight: var(--font-weight--stronger);
  text-decoration: none;

  ${(p) =>
    p.weight === 'weak' &&
    `
    text-decoration: underline;
    font-weight: var(--font-weight--regular); 
  `}

  &:hover {
    text-decoration: underline;
  }
`
